"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  paletteFromSpec: true
};
exports.paletteFromSpec = paletteFromSpec;
var _PaletteManager = require("../PaletteManager");
var _block = require("./block");
Object.keys(_block).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _block[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _block[key];
    }
  });
});
var _style = require("../style");
var _migrate = require("./migrate");
function paletteFromSpec(spec, batches, nft, blockTypes, variableTypes, convertTypes) {
  var _spec$root$vars;
  (0, _migrate.migratePaletteSpec)(spec);
  const palette = new _PaletteManager.PaletteManager(spec.name, spec.schemaVersion, spec.param, batches, nft, blockTypes, variableTypes, convertTypes);
  if (spec.abis) {
    palette.registry.abis.addAll(spec.abis);
  }
  palette.style = new _style.StyleManager(spec.style || [], palette.registry);
  palette.color = new _style.ColorManager(spec.colors || {}, palette.registry);
  let root = palette.setRoot(spec.root);
  palette.setPages(spec.param, spec.pages || []);
  if (((_spec$root$vars = spec.root.vars) === null || _spec$root$vars === void 0 ? void 0 : _spec$root$vars.length) > 0) {
    root.block.variable.addVariables();
  }
  root.block.variable.registerVariables();
  (0, _block.addBlocksFromSpec)(root.block, spec.root.children);
  return Object.freeze(palette);
}
//# sourceMappingURL=index.js.map